import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'

const Date = ({ date, className = '', format = 'MMMM DD, YYYY' }) => (
  <span className={className}>{moment(date).format(format)}</span>
)

Date.propTypes = {
  date: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  className: PropTypes.string,
  format: PropTypes.string,
}

export default Date



// WEBPACK FOOTER //
// ./src/components/Date.js